import additionalActivate from './kr/additionalActivate.json';
import additionalConfirmOverseasDeparture from './kr/additionalConfirmOverseasDeparture.json';
import additionalCreateARSAuthNumber from './kr/additionalCreateARSAuthNumber.json';
import allTmpAccList from './kr/allTmpAccList.json';
import functionsAccountList from './kr/functionsAccountList.json';
import functionsSearchFindAddress from './kr/functionsSearchFindAddress.json';
import functionsSearchFindAddressRefine from './kr/functionsSearchFindAddressRefine.json';
import functionsSearchFindBranch from './kr/functionsSearchFindBranch.json';
import functionsSearchFindEmployee from './kr/functionsSearchFindEmployee.json';
import functionsSearchFindOffice from './kr/functionsSearchFindOffice.json';
import settingsCodeList from './kr/settingsCodeList.json';
import settingsCodeListBankCode from './kr/settingsCodeListBankCode.json';
import tokensActivate from './kr/tokensActivate.json';

export const MockConfig = {
  ['/utilities/settings/code/list']: () => settingsCodeList,
  ['/utilities/settings/code/listBankCode']: () => settingsCodeListBankCode,
  ['/auth/verification/tokens/activate']: () => tokensActivate,
  ['/auth/verification/additional/activate']: () => additionalActivate,
  ['/auth/verification/additional/createARSAuthNumber']: () => additionalCreateARSAuthNumber,
  ['/auth/verification/additional/confirmOverseasDeparture']: () =>
    additionalConfirmOverseasDeparture,
  ['/auth/functions/account/list']: () => functionsAccountList,
  ['/utilities/functions/search/findAddress']: () => functionsSearchFindAddress,
  ['/utilities/functions/search/findAddressRefine']: () => functionsSearchFindAddressRefine,
  ['/utilities/functions/search/findEmployee']: () => functionsSearchFindEmployee,
  ['/utilities/functions/search/findBranch']: () => functionsSearchFindBranch,
  ['/utilities/functions/search/findOffice']: () => functionsSearchFindOffice,
  ['/services/customer/certificatesInquiry/allTmpAccList']: () => allTmpAccList,
};
